import { IonContent } from '@ionic/angular';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import {
  AlertController,
  LoadingController,
  Platform,
  PopoverController
} from '@ionic/angular';
import { PhotoService, ClientService } from 'src/app/services';
import { Utilities } from 'src/app/utilities/utilities';
import { ENV_CONFIG } from 'src/bin/env.config';
import { PhotoModel } from '../booking-photos-manager/booking-photos-manager.component';

@Component({
  selector: 'smr-booking-photo-card',
  templateUrl: './booking-photo-card.component.html',
  styleUrls: ['./booking-photo-card.component.scss']
})
export class BookingPhotoCardComponent {

  @Input() clientID: number;
  @Input() photo: PhotoModel;

  @Input() content: IonContent;

  @Output() viewPhoto = new EventEmitter<PhotoModel>();
  @Output() profilePhoto = new EventEmitter<string>();

  @Output() deletePhoto = new EventEmitter<number>();

  public BOOKING_PHOTO_ROOT: string;

  public THUMBNAIL_PHOTO_ROOT: string;

  @ViewChild('popover') popover;
  isMenuOpen = false;

  constructor(
    public platform: Platform,
    private photoService: PhotoService,
    private alertController: AlertController,
    private loadingCtrl: LoadingController,
    private popoverController: PopoverController,
    private clientService: ClientService
  ) {
    this.BOOKING_PHOTO_ROOT = ENV_CONFIG.BOOKING_PHOTO_ROOT;
    this.THUMBNAIL_PHOTO_ROOT = ENV_CONFIG.THUMBNAIL_PHOTO_ROOT;
  }

  // public getPhotoType(): string {
  //   return Utilities.getPhotoType(this.photo.photoType);
  // }

  public getFullResolutionLink(): string {
    return ENV_CONFIG.BOOKING_PHOTO_FULL_RES_ROOT + '/' + this.photo.name;
  }

  public showMenu(ev) {
    this.popover.event = ev;
    this.isMenuOpen = true;
  }

  public async onDownload() {
    this.isMenuOpen = false;
    const loader = await this.loadingCtrl.create({ spinner: 'crescent' });
    loader.present();
    this.photoService
      .convertPhotoURLToBase64(this.getFullResolutionLink())
      .subscribe({
        next: (base64) => {
          loader.dismiss().then(() => {
            if(!this.platform.is('capacitor')){
              const time = new Date()
              var a = document.createElement("a");
              a.href = base64;
              a.download = `${time.getFullYear()}-${time.getMonth()+1}-${time.getDate()}-${time.getHours()}-${time.getMinutes()}-${time.getSeconds()}.png`
              a.click();
              return
            }
            this.base64Download(base64);
          });
        },
        error: (err) => {
          loader.dismiss().then(() => {
            this.alertController
              .create(Utilities.getDefaultErrorMessageConfig())
              .then((alert) => alert.present());
          });
        }}
      );
  }

  public base64Download(bas64Image: string) {
    // src: // https://stackoverflow.com/questions/10473932/browser-html-force-download-of-image-from-src-dataimage-jpegbase64
    // atob to base64_decode the data-URI
    const imageData: string = atob(bas64Image.split(',')[1]);
    const arraybuffer: ArrayBuffer = new ArrayBuffer(imageData.length);
    const view: Uint8Array = new Uint8Array(arraybuffer);
    let blob: Blob;

    for (var i = 0; i < imageData.length; i++) {
      // todo tslint
      view[i] = imageData.charCodeAt(i) & 0xff;
    }

    try {
      blob = new Blob([arraybuffer], { type: 'application/octet-stream' });
    } catch (e) {
      // The BlobBuilder API has been deprecated in favour of Blob, but older
      // browsers don't know about the Blob constructor
      // IE10 also supports BlobBuilder, but since the `Blob` constructor
      //  also works, there's no need to add `MSBlobBuilder`.
      const bb = new (window['WebKitBlobBuilder'] ||
        window['MozBlobBuilder'])();
      bb.append(arraybuffer);
      blob = bb.getBlob('application/octet-stream'); // <-- Here's the Blob
    }

    // Use the URL object to create a temporary URL
    var url = (window['webkitURL'] || window.URL).createObjectURL(blob);
    location.href = url;
  }

  public onViewPhoto() {
    this.viewPhoto.emit(this.photo);
  }

  public share() {
    this.isMenuOpen = false;

  }

  public addNote() {
    this.isMenuOpen = false;
  }

  public setAsProfilePic() {
    this.isMenuOpen = false;
    this.clientService.updateClientProfilePhoto(this.clientID, this.photo.name).subscribe((res) => {
      this.profilePhoto.emit(this.photo.name);
    })
  }

  public delete() {
    this.isMenuOpen = false;

    this.clientService.deleteClientPhotos([this.photo.id]).subscribe((res) => {
      this.deletePhoto.emit(this.photo.id)
    })
  }
}
